import React from 'react'

export default (props) => {
  return (<h1>About me</h1>)
}


// WEBPACK FOOTER //
// ./src/components/about.js